import React, { PropsWithChildren } from 'react';
import { getStaticMediaUrl } from 'utils/Urls';
import symbolRequests from 'assets/symbols/symbol--requests.svg';
import symbolAdd from 'assets/symbols/symbol--add.svg';
import symbolAddHelp from 'assets/symbols/symbol--add--help.svg';
import symbolAddSearch from 'assets/symbols/symbol--add--search.svg';
import symbolAddWhite from 'assets/symbols/symbol--add--white.svg';
import symbolAdd1 from 'assets/symbols/symbol--add1.png';
import symbolCrossAccent from 'assets/symbols/symbol--cross--accent.svg';
import symbolCrossDark from 'assets/symbols/symbol--cross--dark.svg';
import symbolCross from 'assets/symbols/symbol--cross.svg';
import symbolExpand from 'assets/symbols/symbol--expand.png';
import symbolHelp from 'assets/symbols/symbol--help.svg';
import symbolIncompleteAccent from 'assets/symbols/symbol--incomplete--accent.svg';
import symbolIncompleteDark from 'assets/symbols/symbol--incomplete--dark.svg';
import symbolIncomplete from 'assets/symbols/symbol--incomplete.svg';
import symbolInvite from 'assets/symbols/symbol--invite.svg';
import symbolRemind from 'assets/symbols/symbol--remind.svg';
import symbolSearchWhite from 'assets/symbols/symbol--search--white.svg';
import symbolSubtract from 'assets/symbols/symbol--subtract.svg';
import symbolSubtract1 from 'assets/symbols/symbol--subtract1.png';
import symbolTickAccent from 'assets/symbols/symbol--tick--accent.svg';
import symbolTickDark from 'assets/symbols/symbol--tick--dark.svg';
import symbolTick from 'assets/symbols/symbol--tick.svg';
import symbolChat from 'assets/symbols/chat-icon.svg';
import styles from './index.module.scss';

const ImageSymbolAssetMap = {
  requests: symbolRequests,
  ADD: symbolAdd,
  'add--help': symbolAddHelp,
  'add--search': symbolAddSearch,
  'add--white': symbolAddWhite,
  add: symbolAdd,
  add1: symbolAdd1,
  'cross--accent': symbolCrossAccent,
  'cross--dark': symbolCrossDark,
  cross: symbolCross,
  expand: symbolExpand,
  help: symbolHelp,
  'incomplete--accent': symbolIncompleteAccent,
  'incomplete--dark': symbolIncompleteDark,
  incomplete: symbolIncomplete,
  invite: symbolInvite,
  remind: symbolRemind,
  'search--white': symbolSearchWhite,
  subtract: symbolSubtract,
  subtract1: symbolSubtract1,
  'tick--accent': symbolTickAccent,
  'tick--dark': symbolTickDark,
  tick: symbolTick,
  chat: symbolChat,
};

export function AnchorCard({
  href,
  heading,
  children,
  newTab = false,
  imageSymbolType,
}: PropsWithChildren<{
  href?: string;
  heading: string;
  newTab?: boolean;
  imageSymbolType: keyof typeof ImageSymbolAssetMap;
}>) {
  return (
    <a href={href} target={newTab ? '_blank' : '_self'} className="button__cta">
      <img src={getStaticMediaUrl(ImageSymbolAssetMap[imageSymbolType])} alt={imageSymbolType} />
      <h3 className="text-2xl font-heading mb-6">{heading}</h3>
      {children ? <h5 className={styles['CardBody']}>{children}</h5> : null}
    </a>
  );
}

export function ClickableCard({
  heading,
  children,
  imageSymbolType,
  onClick,
  className = '',
}: PropsWithChildren<{
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  heading: string;
  imageSymbolType: keyof typeof ImageSymbolAssetMap;
  className?: string;
}>) {
  return (
    <span onClick={onClick} className={`button__cta cursor-pointer ${className}`}>
      <img src={getStaticMediaUrl(ImageSymbolAssetMap[imageSymbolType])} alt={imageSymbolType} />
      <h3 className="text-2xl font-heading mb-6">{heading}</h3>
      {children ? <h5 className={styles['CardBody']}>{children}</h5> : null}
    </span>
  );
}

export function PlainCard({
  href,
  heading,
  children,
  target
}: PropsWithChildren<{
  href?: string;
  heading: string;
  target?: string;
}>) {
  return (
    <a href={href} target={target ? target : '_self'} className="button__cta">
      <h3 className="text-2xl font-heading mb-6">{heading}</h3>
      {children ? <div className={styles['CardText']}>{children}</div> : null}
    </a>
  );
}